export interface ShippingPack {
  id: string;
  key: string;
  description: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  length: number;
  width: number;
  height: number;
  weight: number;
  default: number;
}
